import { Card, CardBody } from 'reactstrap';
import React from 'react';
const NotFound = () => /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
  style: {
    margin: '25px'
  }
}, /*#__PURE__*/React.createElement("h2", null, "That URL was not found!"), /*#__PURE__*/React.createElement("h4", null, "Please enter another URL or make a selection from the navigation tabs above"))));
export default NotFound;